import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Guid, isNotNil } from '@web/utils';
import { WarehouseProductType } from '../../enums/warehouse-product-type';
import {
  QuantityUnit,
  QuantityUnitComponent,
} from '@web/shared/module/measurement';
import {
  BooleanPipe,
  DetailsViewComponent,
  NoDataComponent,
} from '@web/shared/ui';
import { FetchWarehouseOwnerByIdPipe } from '../../pipes/fetch-warehouse-owner-by-id.pipe';
import { WarehouseProductTypePipe } from '../../pipes/warehouse-product-type.pipe';

@Component({
  selector: 'app-warehouse-receipt-product-details-attributes',
  imports: [
    CommonModule,
    DetailsViewComponent,
    FetchWarehouseOwnerByIdPipe,
    QuantityUnitComponent,
    NoDataComponent,
    WarehouseProductTypePipe,
    BooleanPipe,
  ],
  templateUrl: './warehouse-receipt-product-details-attributes.component.html',
  styleUrl: './warehouse-receipt-product-details-attributes.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WarehouseReceiptProductDetailsAttributesComponent {
  public readonly batchNumber = input.required<string>();
  public readonly brand = input.required<string>();
  public readonly durabilityInformation = input.required<string>();
  public readonly id = input.required<Guid>();
  public readonly name = input.required<string>();
  public readonly ownerId = input.required<Guid>();
  public readonly promotion = input.required<boolean>();
  public readonly quantity = input.required<number>();
  public readonly sku = input.required<string>();
  public readonly type = input.required<WarehouseProductType>();
  public readonly unit = input.required<QuantityUnit>();

  protected readonly isNotNil = isNotNil;
}
